import React from 'react'
import styles from './style.module.scss'
import F1Heading from '../F1Heading'
import PropTypes from 'prop-types'

const Experience = ({ year, race }) => {
  return (
        <div className={styles.experience}>
            <div className={styles.exp}>
                <F1Heading title={year} />
                <span className={styles.details}>Years of
                    experience</span>
            </div>
            <div className={styles.line}></div>
            <div className={styles.exp}>
                <F1Heading title={race} />
                <span className={styles.details}>Races
                    covered</span>
            </div>
        </div>
  )
}

Experience.propTypes = {
  year: PropTypes.string,
  race: PropTypes.string
}

export default Experience
